import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Card} from "../../../../../../../components/card/card.jsx";
import Button from "../../../../../../../components/button/button.jsx"
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../../utils/aggrid-utils.js";
import GenericEditRemoveCellRenderer
    from "../../../../../agents/form/components/tabs/generic-edit-remove-cell-renderer.jsx";
import ModalGroups from "./modal-groups.jsx";
import InputForm from "../../../../../../../components/input/input-form.jsx";
import {FaEraser} from "react-icons/fa";
import {normalizeFilterText} from "../../../../../../../utils/normalizeFilterText.js";

const Groups = ({groups, setGroups}) => {
    const gridRef = useRef(null);
    const [filter, setFilter] = useState("")
    const [modal, setModal] = useState(false)

    const remove = ({id}) => {
        setGroups(prev => prev.filter(g => g.id !== id));
    }

    const [columnDefs] = useState([
        {headerName: "Descrição", field: "description", flex: 1, sort: "asc", getQuickFilterText: ({value}) => normalizeFilterText(value)},
        {
            headerName: "", field: "", width: 50,
            cellRenderer: GenericEditRemoveCellRenderer,
            cellRendererParams: {remove, noEdit: false}
        },
    ]);

    const changeFilter = (value) => {
        const normalized = normalizeFilterText(value);

        setFilter(value)
        onFilterTextBoxChanged(normalized);
    }

    const onFilterTextBoxChanged = useCallback((value) => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            value,
        );
    }, []);

    const rowClassRules = useMemo(() => {
        return {
            "new-table-data": ({data}) => !!data.new
        };
    }, []);

    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Grupos permitidos</Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className={"col-span-12 flex gap-4"}>
                        <Button onClick={() => setModal(true)}>Adicionar</Button>
                        <InputForm
                            classNameWrapper={"w-full"}
                            id="description"
                            name="description"
                            value={filter}
                            onChange={({target: {value}}) => changeFilter(value)}
                           label="Descrição"/>

                        <div>
                            <Button target={"primary-outline"} onClick={() => changeFilter("")}>
                                <FaEraser/>
                            </Button>
                        </div>
                    </div>
                    <div className="flex gap-4">
                    </div>
                    <div className={"h-[calc(100vh-291px)] mt-3 aggrid-groups"}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={groups}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                            onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                            rowClassRules={rowClassRules}
                        />
                    </div>
                </Card.Body>
            </Card>

            <ModalGroups
                groups={groups}
                modal={modal}
                setModal={setModal}
                setGroups={setGroups}
            />
        </>
    );
};

export default Groups;